import { OptionallyVisible } from 'components';
import { useTranslation } from 'react-i18next';
import { MerchantKyc } from 'services/merchants/types';

import { Button } from 'components/buttons';

import { LABELS } from '../../keys';
import { isKycApprovedStatus } from '../../utils';
import { TablePlaceholderContainer, TablePlaceholderText } from './styles';

interface SettlementTablePlaceholderProps {
  action: () => void;
  kyc?: MerchantKyc;
}

export const SettlementTablePlaceholder = ({ action, kyc }: SettlementTablePlaceholderProps) => {
  const { t } = useTranslation();

  const canAddBankAccount = isKycApprovedStatus(kyc?.kycStatus);

  return (
    <TablePlaceholderContainer>
      <TablePlaceholderText>{t(LABELS.PAYOUT.PLACEHOLDER)}</TablePlaceholderText>
      <OptionallyVisible visible={canAddBankAccount}>
        <Button secondary onClick={action}>
          {t(LABELS.PAYOUT.ADD_METHOD)}
        </Button>
      </OptionallyVisible>
    </TablePlaceholderContainer>
  );
};
